<template>
  <div class="hero--info bg-faun">
    <div class="pt-16 sm:pt-24 pb-8 sm:pb-12">
      <Container>
        <FadeIn class="text-center max-w-2xl mx-auto">
          <div class="mb-2 md:mb-4" v-if="content?.pretitle">
            <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
              {{ content.pretitle }}
            </span>
          </div>
          <h1 id="main-title" class="text-3xl leading-[1.25] sm:text-4xl sm:leading-[1.2] md:text-5xl md:leading-[1.12] font-bold tracking-tight text-gray-900 lora">
            {{ content.title }}
          </h1>
          <p v-if="content.title === 'Webinars'" class="text-subtitle">
            Discover topical roundtables and demonstrations of the Elker platform. Register for one of our upcoming live webinars. <NuxtLink :to="$localePath('/contact')">Contact us</NuxtLink> if you missed one of the webinars and you would like the recording.
          </p>
          <p v-else class="text-subtitle" v-if="content.subtitle" v-interpolation v-html="content.subtitle"></p>
        </FadeIn>
      </Container>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>